import Keycloak from "keycloak-js";

function requiredEnv(name) {
  const value = import.meta.env?.[name] || globalThis.process?.env?.[name];
  if (!value) {
    throw new Error(`Missing required frontend environment variable: ${name}`);
  }
  return value;
}

const keycloak = new Keycloak({
  url: requiredEnv("VITE_KEYCLOAK_URL"),
  realm: requiredEnv("VITE_KEYCLOAK_REALM"),
  clientId: requiredEnv("VITE_KEYCLOAK_CLIENT"),
});

export default keycloak;
